import styles from './spinner.module.scss';

export function Spinner() {
  return (
    <div className={styles.SpinnerWrapper}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        width={20}
        height={20}
      >
        <path
          fill={'#0c1831'}
          d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2z"
        />
      </svg>
    </div>
  );
}

export default Spinner;
